function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Search drawer (`#SearchAside`) — empty state (Query Suggestions + best sellers)
 * and typed product search via Algolia multi-search (same product index as PLP).
 */

import 'snippets/card/card';
import Swiper from 'swiper';
import { FreeMode, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
import { getAlgoliaProductIndexName } from 'lib/algolia/constants';
import { renderProductCard, setAlgoliaSwatchColorLookup } from 'lib/algolia/algolia-product-card-html';
import { getAlgoliaClient } from 'lib/algolia/algolia-client';
import { fetchPopularTerms } from 'lib/algolia/algolia-popular-terms';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
var DEBOUNCE_MS = 300;
var QUERY_SUGGESTIONS_LIMIT = 10;
var POPULAR_CHIPS_MOBILE_MAX_PX = 767;
var POPULAR_CHIPS_SPACE_BETWEEN = 4;
function fetchBestsellerHits(_x, _x2) {
  return _fetchBestsellerHits.apply(this, arguments);
}
function _fetchBestsellerHits() {
  _fetchBestsellerHits = _asyncToGenerator(function* (client, hitsLimit) {
    var _res$results$;
    var indexName = getAlgoliaProductIndexName();
    var res = yield client.search({
      requests: [{
        indexName,
        query: '',
        hitsPerPage: hitsLimit,
        distinct: true
      }]
    });
    return ((_res$results$ = res.results[0]) === null || _res$results$ === void 0 ? void 0 : _res$results$.hits) || [];
  });
  return _fetchBestsellerHits.apply(this, arguments);
}
var popularSearchMql = window.matchMedia("(max-width: ".concat(POPULAR_CHIPS_MOBILE_MAX_PX, "px)"));
var popularChipsSwiper = null;
var popularChipsMqlListener = null;
function destroyPopularChipsSwiper() {
  if (popularChipsMqlListener) {
    popularSearchMql.removeEventListener('change', popularChipsMqlListener);
    popularChipsMqlListener = null;
  }
  if (popularChipsSwiper) {
    popularChipsSwiper.destroy(true, true);
    popularChipsSwiper = null;
  }
}
function syncPopularChipsSwiperLayout(swiperRoot) {
  if (!swiperRoot) return;
  swiperRoot.classList.toggle('search-aside__popular-chips--desktop-layout', !popularSearchMql.matches);
  if (!popularChipsSwiper) return;
  if (popularSearchMql.matches) {
    popularChipsSwiper.enable();
  } else {
    popularChipsSwiper.disable();
  }
  popularChipsSwiper.update();
}
function ensurePopularChipsSwiper(swiperRoot) {
  if (popularChipsSwiper) {
    syncPopularChipsSwiperLayout(swiperRoot);
    return popularChipsSwiper;
  }
  var scrollbarEl = swiperRoot.querySelector('.search-aside__popular-scrollbar');
  var swiperOptions = {
    modules: [FreeMode, Scrollbar],
    enabled: popularSearchMql.matches,
    slidesPerView: 'auto',
    spaceBetween: POPULAR_CHIPS_SPACE_BETWEEN,
    freeMode: true,
    watchOverflow: true
  };
  if (scrollbarEl) {
    swiperOptions.scrollbar = {
      el: scrollbarEl,
      draggable: true,
      hide: false
    };
  }
  popularChipsSwiper = new Swiper(swiperRoot, swiperOptions);
  popularChipsMqlListener = () => syncPopularChipsSwiperLayout(swiperRoot);
  popularSearchMql.addEventListener('change', popularChipsMqlListener);
  syncPopularChipsSwiperLayout(swiperRoot);
  return popularChipsSwiper;
}
function renderPopularChips(swiperRoot, slidesWrap, terms, input) {
  var section = swiperRoot === null || swiperRoot === void 0 ? void 0 : swiperRoot.closest('.search-aside__section');
  destroyPopularChipsSwiper();
  slidesWrap.innerHTML = '';
  if (!terms.length) {
    swiperRoot.hidden = true;
    if (section) section.hidden = true;
    return;
  }
  if (section) section.hidden = false;
  swiperRoot.hidden = false;
  var _loop = function _loop(term) {
    var slide = document.createElement('div');
    slide.className = 'swiper-slide search-aside__popular-slide';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--ghost-reversed search-aside__chip';
    btn.textContent = term;
    btn.addEventListener('click', () => {
      input.value = term;
      input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      input.focus();
    });
    slide.appendChild(btn);
    slidesWrap.appendChild(slide);
  };
  for (var term of terms) {
    _loop(term);
  }
  ensurePopularChipsSwiper(swiperRoot);
  popularChipsSwiper.update();
}

/**
 * Shopify `| t` / Liquid often yields literal `&quot;` in the JS string; `innerHTML` alone can leave it unchanged.
 */
function decodeHtmlEntities(str) {
  var s = String(str !== null && str !== void 0 ? str : '').replace(/&quot;/gi, '"').replace(/&#34;/g, '"').replace(/&#x22;/gi, '"').replace(/&apos;/gi, "'").replace(/&#39;/g, "'");
  var div = document.createElement('div');
  div.innerHTML = s;
  return div.textContent || '';
}
function buildSearchResultsUrl(inputEl, query) {
  var _form$getAttribute;
  var form = inputEl === null || inputEl === void 0 ? void 0 : inputEl.closest('form');
  var action = (form === null || form === void 0 || (_form$getAttribute = form.getAttribute('action')) === null || _form$getAttribute === void 0 ? void 0 : _form$getAttribute.trim()) || '/search';
  var url = new URL(action, window.location.href);
  url.searchParams.set('q', query);
  return "".concat(url.pathname).concat(url.search).concat(url.hash);
}
function syncSearchFullFooter(inputEl, footerEl, linkEl, labelEl, queryRaw) {
  var _window$theme;
  if (!footerEl || !linkEl || !labelEl) return;
  var q = String(queryRaw !== null && queryRaw !== void 0 ? queryRaw : '').trim();
  if (!q.length) {
    footerEl.hidden = true;
    return;
  }
  footerEl.hidden = false;
  var tpl = ((_window$theme = window.theme) === null || _window$theme === void 0 || (_window$theme = _window$theme.strings) === null || _window$theme === void 0 ? void 0 : _window$theme.searchAsideSearchFor) || 'Search for “__QUERY__”';
  labelEl.textContent = decodeHtmlEntities(String(tpl).replace(/__QUERY__/g, q));
  linkEl.setAttribute('href', buildSearchResultsUrl(inputEl, q));
}
function readSwatchColorLookup(root) {
  var _el$textContent;
  var el = root.querySelector('[data-algolia-swatch-colors]');
  var text = el === null || el === void 0 || (_el$textContent = el.textContent) === null || _el$textContent === void 0 ? void 0 : _el$textContent.trim();
  if (!text) return {};
  var map;
  try {
    map = JSON.parse(text);
  } catch (_unused) {
    return {};
  }
  var lookup = {};
  for (var _ref3 of Object.entries(map || {})) {
    var _ref4, _entry$hex, _entry$image;
    var _ref2 = _slicedToArray(_ref3, 2);
    var label = _ref2[0];
    var entry = _ref2[1];
    if (!entry || typeof entry !== 'object') continue;
    lookup[label] = {
      color: String((_ref4 = (_entry$hex = entry.hex) !== null && _entry$hex !== void 0 ? _entry$hex : entry.color) !== null && _ref4 !== void 0 ? _ref4 : '').trim(),
      image: String((_entry$image = entry.image) !== null && _entry$image !== void 0 ? _entry$image : '').trim()
    };
  }
  return lookup;
}
function initSearchAsidePredictive() {
  var cfg = window.algoliaPlp;
  if (!(cfg !== null && cfg !== void 0 && cfg.appId) || !(cfg !== null && cfg !== void 0 && cfg.searchApiKey)) return;
  var aside = document.getElementById('SearchAside');
  var input = document.getElementById('SearchAside-input');
  var emptyEl = document.querySelector('[data-search-aside-empty]');
  var typedEl = document.querySelector('[data-search-aside-typed]');
  var popularSwiperRoot = document.querySelector('[data-search-aside-popular-swiper]');
  var popularSlidesWrap = document.querySelector('[data-search-aside-popular-slides]');
  var bestsellersUl = document.querySelector('[data-search-aside-bestsellers]');
  var hitsUl = document.querySelector('[data-search-aside-hits]');
  var searchFooterEl = document.querySelector('[data-search-aside-search-footer]');
  var searchFooterLink = document.querySelector('[data-search-aside-search-full-link]');
  var searchFooterLabel = document.querySelector('[data-search-aside-search-full-label]');
  if (!aside || !input || !emptyEl || !typedEl || !popularSwiperRoot || !popularSlidesWrap || !bestsellersUl || !hitsUl) {
    return;
  }
  var client;
  try {
    client = getAlgoliaClient();
  } catch (e) {
    console.warn('[Algolia predictive] Client unavailable', e);
    return;
  }
  setAlgoliaSwatchColorLookup(readSwatchColorLookup(aside));
  var hitsLimit = Number(cfg.predictiveHitsLimit) || 6;
  var debounceTimer = null;
  var emptyFetchGen = 0;
  var queryFetchGen = 0;
  function showEmptyShell() {
    emptyEl.hidden = false;
    typedEl.hidden = true;
    if (searchFooterEl) searchFooterEl.hidden = true;
  }
  function showTypedShell() {
    emptyEl.hidden = true;
    typedEl.hidden = false;
  }
  function loadEmptyPanels() {
    var gen = ++emptyFetchGen;
    Promise.all([fetchPopularTerms(client, cfg, QUERY_SUGGESTIONS_LIMIT), fetchBestsellerHits(client, hitsLimit)]).then(_ref5 => {
      var _ref6 = _slicedToArray(_ref5, 2),
        terms = _ref6[0],
        hits = _ref6[1];
      if (gen !== emptyFetchGen) return;
      if (input.value.trim().length > 0) return;
      renderPopularChips(popularSwiperRoot, popularSlidesWrap, terms, input);
      bestsellersUl.innerHTML = hits.slice(0, hitsLimit).map(h => renderProductCard(h, {
        swatchCap: 3
      })).join('');
    }).catch(e => {
      console.warn('[Algolia predictive] Empty state load failed', e);
    });
  }
  function runProductSearch(q) {
    var gen = ++queryFetchGen;
    client.search({
      requests: [{
        indexName: getAlgoliaProductIndexName(),
        query: q,
        hitsPerPage: hitsLimit,
        distinct: true
      }]
    }).then(res => {
      if (gen !== queryFetchGen) return;
      var result = res.results[0];
      var list = ((result === null || result === void 0 ? void 0 : result.hits) || []).slice(0, hitsLimit);
      hitsUl.innerHTML = list.map(h => renderProductCard(h, {
        swatchCap: 3
      })).join('');
      syncSearchFullFooter(input, searchFooterEl, searchFooterLink, searchFooterLabel, q);
    }).catch(e => {
      console.warn('[Algolia predictive] Product search failed', e);
    });
  }
  function refreshFromInput() {
    // Drawer closed — skip (more reliable than class timing vs `aside:opened`).
    if (aside.getAttribute('aria-hidden') === 'true') return;
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = null;
    if (!q.length) {
      showEmptyShell();
      loadEmptyPanels();
      return;
    }
    showTypedShell();
    syncSearchFullFooter(input, searchFooterEl, searchFooterLink, searchFooterLabel, q);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      var latest = input.value.trim();
      if (!latest.length) return;
      runProductSearch(latest);
    }, DEBOUNCE_MS);
  }
  input.addEventListener('input', refreshFromInput);
  iamotaEventHandler.subscribe('aside:opened:SearchAside', () => {
    refreshFromInput();
  });
  iamotaEventHandler.subscribe('aside:closed:SearchAside', () => {
    clearTimeout(debounceTimer);
    debounceTimer = null;
    emptyFetchGen += 1;
    queryFetchGen += 1;
  });
}
document.addEventListener('DOMContentLoaded', initSearchAsidePredictive);